// utils/mapbox.ts
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { MAPBOX_TOKEN } from '@settings';
export const fetchAddressSuggestions = (query) => __awaiter(void 0, void 0, void 0, function* () {
    if (!query)
        return [];
    try {
        const response = yield axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`, {
            params: {
                access_token: MAPBOX_TOKEN,
                autocomplete: true,
                limit: 5,
                country: 'ca', // Adjust the country code as needed
            },
        });
        if (response.data && response.data.features) {
            return response.data.features.map((feature) => ({
                place_name: feature.place_name,
            }));
        }
        return [];
    }
    catch (error) {
        console.error('Error fetching address suggestions:', error);
        return [];
    }
});
